import { AxiosInstance, AxiosRequestConfig } from "axios"

import { AddFavouritesListResponse } from "./createFavouriteList"

export interface RenameFavoriteListRequest extends Partial<AxiosRequestConfig> {
  params: RenameFavoritesListParams
}

export interface RenameFavoritesListParams {
  favoriteId: string
  favouriteListName: string
}

export function renameFavoriteListApi(
  { params }: RenameFavoriteListRequest,
  axiosInstance: AxiosInstance,
): Promise<AddFavouritesListResponse> {
  const url = `/user/favouritelist/renamefavouritelist`

  return axiosInstance({
    data: params,
    method: "put",
    url,
  }) as Promise<AddFavouritesListResponse>
}
